/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.teams.rpc.AppFatTeams
 */
import * as References from './AppFatTeams';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.teams.rpc.AppFatTeams#getByHub
 */
export const GET_BY_HUB_QUERY_FIELD_NAME = 'com_hubspot_teams_rpc_AppFatTeams_getByHub';
export const GET_BY_HUB_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_BY_HUB_QUERY_FIELD_NAME,
  args: ['includeHierarchy', 'userFilters'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getByHubRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.teams.rpc.AppFatTeams#getByHubWithHierarchy
 */
export const GET_BY_HUB_WITH_HIERARCHY_QUERY_FIELD_NAME = 'com_hubspot_teams_rpc_AppFatTeams_getByHubWithHierarchy';
export const GET_BY_HUB_WITH_HIERARCHY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_BY_HUB_WITH_HIERARCHY_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getByHubWithHierarchyRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.teams.rpc.AppFatTeams#getAccessibleByPortalUser
 */
export const GET_ACCESSIBLE_BY_PORTAL_USER_QUERY_FIELD_NAME = 'com_hubspot_teams_rpc_AppFatTeams_getAccessibleByPortalUser';
export const GET_ACCESSIBLE_BY_PORTAL_USER_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ACCESSIBLE_BY_PORTAL_USER_QUERY_FIELD_NAME,
  args: ['includeChildTeamMembers', 'includeHierarchy', 'userFilters'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getAccessibleByPortalUserRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.teams.rpc.AppFatTeams#getAccessibleByPortalUserUnique
 */
export const GET_ACCESSIBLE_BY_PORTAL_USER_UNIQUE_QUERY_FIELD_NAME = 'com_hubspot_teams_rpc_AppFatTeams_getAccessibleByPortalUserUnique';
export const GET_ACCESSIBLE_BY_PORTAL_USER_UNIQUE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ACCESSIBLE_BY_PORTAL_USER_UNIQUE_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getAccessibleByPortalUserUniqueRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.teams.rpc.AppFatTeams#getById
 */
export const GET_BY_ID_QUERY_FIELD_NAME = 'com_hubspot_teams_rpc_AppFatTeams_getById';
export const GET_BY_ID_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_BY_ID_QUERY_FIELD_NAME,
  args: ['teamId', 'userFilters'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.getByIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.teams.rpc.AppFatTeams#getByIds
 */
export const GET_BY_IDS_QUERY_FIELD_NAME = 'com_hubspot_teams_rpc_AppFatTeams_getByIds';
export const GET_BY_IDS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_BY_IDS_QUERY_FIELD_NAME,
  args: ['teamIds', 'userFilters'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.getByIdsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.teams.rpc.AppFatTeams#create
 */
export const CREATE_MUTATION_FIELD_NAME = 'com_hubspot_teams_rpc_AppFatTeams_create';
export const CREATE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_MUTATION_FIELD_NAME,
  args: ['fatTeamEgg'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.createRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.teams.rpc.AppFatTeams#updateFatTeams
 */
export const UPDATE_FAT_TEAMS_MUTATION_FIELD_NAME = 'com_hubspot_teams_rpc_AppFatTeams_updateFatTeams';
export const UPDATE_FAT_TEAMS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_FAT_TEAMS_MUTATION_FIELD_NAME,
  args: ['fatTeam'],
  fetcher(request, ctx) {
    var _ctx$customClient8;
    return ((_ctx$customClient8 = ctx.customClient) !== null && _ctx$customClient8 !== void 0 ? _ctx$customClient8 : chirpClient).call(References.updateFatTeamsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.teams.rpc.AppFatTeams#updateParentTeams
 */
export const UPDATE_PARENT_TEAMS_MUTATION_FIELD_NAME = 'com_hubspot_teams_rpc_AppFatTeams_updateParentTeams';
export const UPDATE_PARENT_TEAMS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_PARENT_TEAMS_MUTATION_FIELD_NAME,
  args: ['teamIds', 'parentTeamId'],
  fetcher(request, ctx) {
    var _ctx$customClient9;
    return ((_ctx$customClient9 = ctx.customClient) !== null && _ctx$customClient9 !== void 0 ? _ctx$customClient9 : chirpClient).call(References.updateParentTeamsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.teams.rpc.AppFatTeams#deleteTeams
 */
export const DELETE_TEAMS_MUTATION_FIELD_NAME = 'com_hubspot_teams_rpc_AppFatTeams_deleteTeams';
export const DELETE_TEAMS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DELETE_TEAMS_MUTATION_FIELD_NAME,
  args: ['teamIds'],
  fetcher(request, ctx) {
    var _ctx$customClient10;
    return ((_ctx$customClient10 = ctx.customClient) !== null && _ctx$customClient10 !== void 0 ? _ctx$customClient10 : chirpClient).call(References.deleteTeamsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.teams.rpc.AppFatTeams#setPortalUserTeamsState
 */
export const SET_PORTAL_USER_TEAMS_STATE_MUTATION_FIELD_NAME = 'com_hubspot_teams_rpc_AppFatTeams_setPortalUserTeamsState';
export const SET_PORTAL_USER_TEAMS_STATE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SET_PORTAL_USER_TEAMS_STATE_MUTATION_FIELD_NAME,
  args: ['userId', 'portalUserTeamState'],
  fetcher(request, ctx) {
    var _ctx$customClient11;
    return ((_ctx$customClient11 = ctx.customClient) !== null && _ctx$customClient11 !== void 0 ? _ctx$customClient11 : chirpClient).call(References.setPortalUserTeamsStateRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});